"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpperAverage = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../../../common");
const AverageBox_1 = require("./AverageBox");
const popup_1 = require("../../../../base/popup");
const UpperMemberList_1 = require("./UpperMemberList");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const UpperAverageStyled = styled_components_1.default.div `
	${props => (props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	.fixed {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 16px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 400;
		position: relative;
		align-self: stretch;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	.score-container {
		display: flex;
		flex-direction: row;
		gap: 20px;
		align-items: center;
		justify-content: flex-end;
		position: relative;
	}
	.score {
		display: flex;
		flex-direction: row;
		gap: 4px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}
	.value {
		color: var(--color-black, #101010);
		text-align: right;
		font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--h3-font-size, 20px);
		line-height: var(--h3-line-height, 36px);
		font-weight: var(--h3-font-weight, 700);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.fixed2 {
		color: var(--color-black, #101010);
		text-align: right;
		font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--h4-font-size, 16px);
		line-height: var(--h4-line-height, 32px);
		font-weight: var(--h4-font-weight, 700);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.btn-view-user {
		background: var(--tur-l, #458c94);
		border-radius: 10px;
		padding: 6px 12px 6px 12px;
		display: flex;
		flex-direction: row;
		gap: 10px;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		position: relative;
	}
	.txt {
		color: var(--color-white, #ffffff);
		text-align: right;
		font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--h5-font-size, 16px);
		line-height: var(--h5-line-height, 24px);
		font-weight: var(--h5-font-weight, 700);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.score-wrap {
		width: 100%;
		justify-content: space-between;
	}
	.show-wrap {
		width: 100%;
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	.fixed {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--b2-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b2-font-size, 18px);
		line-height: var(--b2-line-height, 36px);
		font-weight: var(--b2-font-weight, 400);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	.score-container {
		display: flex;
		flex-direction: row;
		gap: 20px;
		align-items: center;
		justify-content: flex-end;
		position: relative;
	}
	.score {
		display: flex;
		flex-direction: row;
		gap: 4px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}
	.value {
		color: var(--color-black, #101010);
		text-align: right;
		font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--h3-font-size, 24px);
		line-height: var(--h3-line-height, 36px);
		font-weight: var(--h3-font-weight, 700);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.fixed2 {
		color: var(--color-black, #101010);
		text-align: right;
		font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--h4-font-size, 20px);
		line-height: var(--h4-line-height, 32px);
		font-weight: var(--h4-font-weight, 700);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.btn-view-user {
		background: var(--tur-l, #458c94);
		border-radius: 10px;
		padding: 6px 12px 6px 12px;
		display: flex;
		flex-direction: row;
		gap: 10px;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		position: relative;
	}
	.txt {
		color: var(--color-white, #ffffff);
		text-align: right;
		font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--h5-font-size, 16px);
		line-height: var(--h5-line-height, 24px);
		font-weight: var(--h5-font-weight, 700);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.score-wrap {
		width: 100%;
	}
`;
exports.UpperAverage = react_1.default.memo(({ test_id, subject_item, average, }) => {
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const onClick = (precedence) => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: UpperMemberList_1.UpperMemberList,
            componentProps: { precedence, subject_item, test_id },
            title: `상위 ${precedence}% 인원보기`,
            width: 564,
            height: isTablet && 'unset',
        });
    };
    const renderItem = (0, react_1.useMemo)(() => (react_1.default.createElement(UpperAverageStyled, { "$isMobile": isMobile, className: "upper-average box-wrap" }, ['10%', '50%'].map(percentage => (react_1.default.createElement("div", { className: "box-wrap-item", key: percentage, style: isMobile ? { flexDirection: 'column' } : {} },
        react_1.default.createElement("div", { className: "score-wrap" },
            react_1.default.createElement("div", { className: "fixed" },
                "\uC0C1\uC704 ",
                percentage,
                " \uD3C9\uADE0"),
            react_1.default.createElement("div", { className: "score-container" },
                react_1.default.createElement("div", { className: "score" },
                    react_1.default.createElement("div", { className: "value" }, average[percentage].score === -1
                        ? '-'
                        : average[percentage].score),
                    react_1.default.createElement("div", { className: "fixed2" }, "\uC810")),
                average[percentage].score !== -1 && !isMobile && (react_1.default.createElement(common_1.Button, { className: "btn_tur xs", text: "\uC778\uC6D0\uBCF4\uAE30", onClick: () => onClick(parseInt(percentage)) })))),
        average[percentage].score !== -1 && isMobile && (react_1.default.createElement("div", { className: "show-wrap" },
            react_1.default.createElement(common_1.Button, { className: "btn_tur xs", text: "\uC778\uC6D0\uBCF4\uAE30", onClick: () => onClick(parseInt(percentage)), styles: {
                    buttonWrap: {
                        width: '100%',
                        padding: isMobile ? '10px' : '10px 12px',
                    },
                } })))))))), [average, isMobile]);
    return react_1.default.createElement(AverageBox_1.AverageBox, { title: "assignment.upperAverage", renderItem: renderItem });
});
